import saveSectionData from './saveSectionData';
import fetchHotelAccordion from 'js/apiCalls/hotelAccordion';

const fetchSectionData = async ({wid, sectionId, hotelId}, dispatch) => {
  const res = await fetchHotelAccordion({
    wid,
    identifier: sectionId,
    hotelId,
  })
  if (res.data) {
    dispatch(saveSectionData(hotelId, wid, res.data))
  }
}

export default (params) => (dispatch) => fetchSectionData(params, dispatch)
